import { BaseFiltroPaginate } from "core/resources/enums/paginate";
import { useCallback, useState } from "react";
import { CollapsibleListCardHookFilter } from ".";

function useCardFilter(unidadeId: string) {
  const [filtro, setFiltro] = useState<CollapsibleListCardHookFilter>({
    page: 1,
    limit: BaseFiltroPaginate.Limit,
    unidadeId,
  });

  const onChangeFiltro = useCallback(
    (newValues: Partial<CollapsibleListCardHookFilter>) => {
      setFiltro((prev: any) => ({ ...prev, ...newValues }));
    },
    []
  );

  return {
    filtro,
    setFiltro,
    onChangeFiltro,
  };
}

export default useCardFilter;
